import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import InternshipEnquiryListLayer from "../components/InternshipEnquiryListLayer";

const InternshipEnquiryListPage = () => {
  return (
    <>
      <MasterLayout>
        <InternshipEnquiryListLayer />
      </MasterLayout>
    </>
  );
};
export default InternshipEnquiryListPage;
